export enum GetstreamVerb {
  HERO = 'hero',
  POST = 'post'
}
